import * as React from "react";
import * as ReactDOM from "react-dom";
import {Link} from "react-router-dom";


export default function RootPage() {
	return (
		<div>
			<h1>ARMOUR SYSTEMS</h1>
			<Link to={`/bid`}>Bid</Link>
		</div>
	);
}
